import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from './store';

export type folderStateType = {
  sortBy?: string;
  orderBy?: string;
  offset?: string;
  search?: string;
  userId?: string;
  subscriberId?: string;
  favorites?: boolean;
  sharedWith?: string;
  people?: any[];
  things?: any[];
  locations?: any[];
  dates?: any[];
  interactions?: any[];
  mediaType?: any[];
  userFolderId?: string;
};

const initialState: folderStateType = {
  sortBy: '',
  orderBy: '',
  offset: '',
  search: '',
  userId: '',
  subscriberId: '',
  favorites: false,
  sharedWith: '',
  people: [],
  things: [],
  locations: [],
  dates: [],
  interactions: [],
  mediaType: [],
  userFolderId: ''
};

export const filterStateSlice = createSlice({
  name: 'filterStateSlice',
  initialState,
  reducers: {
    setFilterDetails: (state, action) => {
      state = { ...action.payload };
      return state;
    },
    resetFilterDetails: () => {
      return initialState;
    }
  }
});

export const { setFilterDetails, resetFilterDetails } =
  filterStateSlice.actions;

export const getFilterDetails = (state: RootState) => state.filterStateSlice;
